import { Track } from "./track";

export class TrackManager {
  private tracks = new Set<Track>();
  private listeners = new Set<() => void>();

  constructor(private ctx: AudioContext) {
  }

  getContext(): AudioContext {
    return this.ctx;
  }

  getTracks(): Track[] {
    return Array.from(this.tracks);
  }

  onChange(callback: () => void): () => void {
    this.listeners.add(callback);
    return () => this.listeners.delete(callback);
  }

  private notifyChange() {
    this.listeners.forEach(listener => listener());
  }

  add(track: Track) {
    this.tracks.add(track);
    this.notifyChange();
  }

  remove(track: Track) {
    this.tracks.delete(track);
    this.notifyChange();
  }

  /** Oublie pistes et écouteurs : le studio qui le tenait est démonté. */
  dispose(): void {
    this.tracks.clear();
    this.listeners.clear();
  }
}
